/**
 * Created by Christof Sander on 07.12.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'dnd',
				'search'
			],
			core: {
				check_callback: function(operation, node, node_parent, node_position, more) {
					var result = false;
					// if(operation == 'move_node'){
					// 	var treesComponent;
					// 	if(more.origin.element && (treesComponent = getComponent($(more.origin.element).closest('.base_trees_trees')))){
					// 		var nodeData = treesComponent.getNodeData(node.id);
					// 		var parentNodeData;
					// 		if(node_parent.id != '#') parentNodeData = treesComponent.getNodeData(node_parent.id);
					//
					// 		result = (
					// 			// move category data elements only into other categories
					// 			(
					// 				nodeData.categoryDataID
					// 				&&
					// 				parentNodeData
					// 				&&
					// 				!parentNodeData.categoryDataID
					// 				&&
					// 				nodeData.categoryID != parentNodeData.categoryID
					// 			)
					// 			||
					// 			// move category into root or other category
					// 			(
					// 				!nodeData.categoryDataID
					// 				&&
					// 				(
					// 					!parentNodeData
					// 					||
					// 					!parentNodeData.categoryDataID
					// 				)
					// 			)
					// 		);
					// 	}
					// }
					return result;
				}
			}
		}
	}
};
